/**
 * @file useSafeTranslations.ts
 * @description
 * -----------------------------------------------------
 * Hook personalizado para manejar traducciones seguras
 * -----------------------------------------------------
 * @version 1.0.0
 * @created 2025-11-17
 * @author Correcta
 * @author Daniel Sentamans
 * @copyright © Correcta
 * @license Private
 */

import { useTranslations } from "use-intl";

export function useSafeTranslation(namespace: string) {
  const t = useTranslations(namespace);

  const safeT = (key: string): string | null => {
    try {
      const result = t(key);
      // Verificar si la traducción devuelve la misma clave (no encontrada)
      return result === key ? null : result;
    } catch {
      return null;
    }
  };

  return safeT;
}
